import { Container } from "@mui/material";
import React from "react";
import { MathJax, MathJaxContext } from "better-react-mathjax";
import ResponsiveAppBar from "./material-ui/ResponsiveAppBar";

const config = {
  loader: { load: ["[tex]/html"] },

  options: {
    enableMenu: false, // set to false to disable the menu
    menuOptions: {
      settings: {
        texHints: true, // put TeX-related attributes on MathML
        semantics: false, // put original format in <semantic> tag in MathML
        zoom: "NoZoom", // or 'Click' or 'DoubleClick' as zoom trigger
        zscale: "200%", // zoom scaling factor
        renderer: "CHTML", // or 'SVG'
        alt: false, // true if ALT required for zooming
        cmd: false, // true if CMD required for zooming
        ctrl: false, // true if CTRL required for zooming
        shift: false, // true if SHIFT required for zooming
        scale: 1, // scaling factor for all math
        inTabOrder: true, // true if tabbing includes math

        assistiveMml: true, // true if hidden assistive MathML should be generated for screen readers
        collapsible: false, // true if complex math should be collapsible
        explorer: false, // true if the expression explorere should be active
      },
    },
  },

  tex: {
    packages: { "[+]": ["html"] },
    inlineMath: [
      ["$", "$"],
      ["(", ")"],
    ],
    displayMath: [
      ["$$", "$$"],
      ["[", "]"],
    ],
  },
};

const Layout = ({ children }) => {
  return (
    <MathJaxContext config={config}>
      <MathJax>
        <ResponsiveAppBar />
        <Container>{children}</Container>
      </MathJax>
    </MathJaxContext>
  );
};

export default Layout;
